<template>
  <div v-if="guideStorageKey">
    <NewUserGuide
      className="home-user-guide"
      :width="310"
      :guideStorageKey="guideStorageKey"
      :stepComponents="stepComponents"
      :dataSource="dataSource"
    />
  </div>
</template>
<script setup>
import { useStore } from 'vuex';
import { onMounted, ref, watch } from 'vue';
import './index.scss';
import NewUserGuide from '@/components/common/NewUserGuide.vue';
import Guide from './Guide.vue';
import { getElePosition } from '../../../../utils/utils';
import config from './config';

const store = useStore();
const guideStorageKey = ref('');

watch(
  () => store.state.userInfo,
  (newValue = {}) => {
    const { userId } = newValue;
    if (userId) {
      guideStorageKey.value = `${userId}-home-guide`;
    }
  },
  { immediate: true }
);
const stepComponents = [Guide, Guide, Guide];
const dataSource = ref(config);
onMounted(() => {
  const { left, top } = getElePosition('upload_voice_btn');
  const hearing = getElePosition('page-tab-/hearing');
  dataSource.value = {
    ...dataSource.value,
    1: {
      ...dataSource.value['1'],
      style: {
        left: `${left}px`,
        top: `${top + 40 + 20}px`,
        position: 'absolute',
      },
      width: '232px',
      arrow: true,
    },
    2: {
      ...dataSource.value['2'],
      style: {
        left: `${hearing.left + 160}px`,
        top: `${hearing.top - 40}px`,
        position: 'absolute',
        width: '232px !important',
      },
      width: '232px',
      arrow: true,
    },
  };
});
</script>
